import React, { Component } from 'react'
import ActivityOneScreen from './components/index'

class ActivityOne extends Component {
  render() {
    return (
      <div>
        <ActivityOneScreen {...this.props} />
      </div>
    )
  }
}

export default ActivityOne



// WEBPACK FOOTER //
// ./src/modules/activity/index.js